import React from "react"
import PropTypes from "prop-types"
import { Card, CardContent, Avatar, Typography, Box, Chip } from "@mui/material"

const ContactCard = ({ contact }) => {
  const fullName = `${contact.firstname || ""} ${contact.lastname || ""}`.trim()
  const displayName = fullName || "Sin nombre"

  const getInitials = name => {
    if (!name) return "?"
    const parts = name.split(" ")
    return parts
      .slice(0, 3)
      .map(n => n[0])
      .join("")
      .toUpperCase()
  }

  return (
    <Card
      elevation={0}
      sx={{
        height: "100%",
        display: "flex",
        flexDirection: "column",
        cursor: "pointer",
        position: "relative",
      }}
    >
      <CardContent
        sx={{
          flexGrow: 1,
          pb: 1,
          minHeight: 230,
          display: "flex",
          flexDirection: "column",
          justifyContent: "space-between",
        }}
      >
        <div>
          <Box
            sx={{
              display: "flex",
              flexDirection: "row",
              alignItems: "flex-start",
              justifyContent: "space-between",
            }}
          >
            <Box
              sx={{
                display: "flex",
                flexDirection: "column",
                alignItems: "flex-start",
                mb: 1,
              }}
            >
              <Avatar
                sx={{
                  bgcolor: "#cccccc",
                  mb: 1,
                  width: 64,
                  height: 64,
                  fontSize: "1.5rem",
                }}
              >
                {getInitials(fullName)}
              </Avatar>
              <Typography
                variant="h6"
                component="h3"
                sx={{
                  fontWeight: 600,
                  fontSize: "1.1rem",
                  color: "#414141",
                }}
              >
                {displayName}
              </Typography>
            </Box>
          </Box>
          <Box
            sx={{
              display: "flex",
              flexDirection: "column",
              gap: 1,
              alignItems: "flex-start",
            }}
          >
            {contact.email && (
              <Box sx={{ display: "flex", alignItems: "center" }}>
                <Typography
                  variant="body2"
                  sx={{
                    color: "#414141",
                    fontSize: "0.875rem",
                    wordBreak: "break-word",
                  }}
                >
                  {contact.email}
                </Typography>
              </Box>
            )}
            {contact.mobile && (
              <Box sx={{ display: "flex", alignItems: "center" }}>
                <Typography
                  variant="body2"
                  sx={{
                    color: "#414141",
                    fontSize: "0.875rem",
                  }}
                >
                  {contact.mobile}
                </Typography>
              </Box>
            )}
          </Box>
        </div>
        {contact.tags &&
          Array.isArray(contact.tags) &&
          contact.tags.length > 0 && (
            <Box sx={{ display: "flex", flexWrap: "wrap", gap: 0.5, mt: 1 }}>
              {contact.tags.map((tag, idx) => (
                <Chip
                  key={tag.tag_name + idx}
                  label={tag.tag_name}
                  size="small"
                  sx={{
                    backgroundColor: tag.tag_color || undefined,
                    color: "#333",
                    borderRadius: "4px",
                  }}
                />
              ))}
            </Box>
          )}
      </CardContent>
    </Card>
  )
}

ContactCard.propTypes = {
  contact: PropTypes.shape({
    id: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
    firstname: PropTypes.string,
    lastname: PropTypes.string,
    email: PropTypes.string,
    mobile: PropTypes.string,
    tags: PropTypes.arrayOf(
      PropTypes.shape({
        tag_name: PropTypes.string.isRequired,
        tag_color: PropTypes.string,
      }),
    ),
  }).isRequired,
}

export default ContactCard
